// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-buttons.liquid so the browser can cache it. Code unchanged.
  /* 11 Oct 2026 (Yass: "I just added 3 numbers for a mobile and it accepted"): phone fields on the site's own forms now
     need a 10-digit Australian number: mobiles (04), landlines (02, 03, 07, 08), 1300 or 1800, or the same with +61.
     Spaces, brackets and dashes are fine. Klaviyo's sign-up forms are left to Klaviyo. */
  (function(){
    var RE=/^(?:0[2-478]\d{8}|61[2-478]\d{8}|1[38]00\d{6})$/;
    var MSG='Enter a 10-digit Australian number, for example 0412 345 678 or 02 9166 3980.';
    function isPhone(i){
      if(!i||i.tagName!=='INPUT'||i.type==='hidden')return false;
      if(!/phone|mobile|tel/i.test((i.name||'')+' '+(i.id||'')+' '+(i.type||'')))return false;
      var f=i.closest('form'); if(!f||/\/cart/.test(f.getAttribute('action')||''))return false;
      return !i.closest('[class*="klaviyo"],[class*="kl-private"]');
    }
    function check(i){
      var v=String(i.value||'').replace(/[\s()+.\-]/g,'');
      if(!v&&!i.required){i.setCustomValidity('');return true;}
      var ok=RE.test(v); i.setCustomValidity(ok?'':MSG); return ok;
    }
    document.addEventListener('input',function(e){if(isPhone(e.target))check(e.target);},true);
    document.addEventListener('submit',function(e){
      var bad=null;
      [].forEach.call(e.target.querySelectorAll('input'),function(i){if(isPhone(i)&&!check(i)&&!bad)bad=i;});
      if(bad){e.preventDefault();e.stopImmediatePropagation();bad.reportValidity();}
    },true);
  })();

/* 11 Oct 2026: set the jobs track height only after a swipe settles */
(function(){
  function init(){
    var t=document.getElementById('lpJobsTrack');
    if(!t||t.dataset.adoreH){return;}
    t.dataset.adoreH='1';
    var cards=t.querySelectorAll('.lp-job'), timer=null;
    function fit(){
      if(!cards.length){return;}
      var c=cards[0], st=c.getBoundingClientRect().width+(parseFloat(getComputedStyle(t).columnGap)||0);
      var i=Math.min(Math.max(Math.round(t.scrollLeft/st),0),cards.length-1);
      t.style.setProperty('--lpj-h',cards[i].offsetHeight+'px');
    }
    t.addEventListener('scroll',function(){clearTimeout(timer);timer=setTimeout(fit,160);},{passive:true});
    if('onscrollend' in window){t.addEventListener('scrollend',fit);}
    window.addEventListener('resize',fit);
    window.addEventListener('load',fit);
    fit();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
